/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2025-09-24 15:01:20
 * @LastEditors: wangqiong 2650366496@qq.com
 * @Description: System Logs 日志
 * @Do not edit
 */
import React from 'react';
import ReactDOM from 'react-dom';
import R from "./router";
import { Provider } from 'react-redux';
import store from './redux/store';
import { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import 'moment/locale/zh-cn';
import 'antd/dist/antd.css';
import './index.scss';
import 'core-js/es'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import "./i18n"; // 引入国际化配置
const lng = localStorage.getItem("i18nextLng");
if (lng === "zh-CN" || lng === "zh-cn") {
  localStorage.setItem("i18nextLng", "zh");
}

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConfigProvider locale={zhCN}>
                <R />
            </ConfigProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);
